import React, { useEffect, useMemo } from 'react'
import Checkbox from '../../../../components/formFields/Checkbox'
import { ClearLocStorageItem, GetLocStorage, SetLocStorage } from '../../../../utils'

const RememberMe = ({ dataObject }) => {

    const savedRememberMeVal = useMemo(() => !!JSON.parse(GetLocStorage('isRememberMe')), [])

    const handleClick = () => {
        if (GetLocStorage('isRememberMe')) {
            ClearLocStorageItem('email')
            ClearLocStorageItem('password')
            ClearLocStorageItem("isRememberMe")
        } else {
            SetLocStorage("isRememberMe", 1)
            SetLocStorage('email', dataObject?.email)
            SetLocStorage('password', dataObject?.password)
        }
    }

    useEffect(() => {
        if (!JSON.parse(GetLocStorage('isRememberMe'))) return
        SetLocStorage('email', dataObject?.email)
        SetLocStorage('password', dataObject?.password)

    }, [dataObject])


    return (<Checkbox isDisabled={!dataObject?.email || !dataObject?.password} onApply={handleClick} label={"remember-me"} value={savedRememberMeVal} />
    )
}

export default RememberMe